export default {
  orange: '#dd7e09',
  brightOrange: '#f69723',
  grey: '#4d4d4e',
  black: '#181818',
  text: 'white'
};
